<template>
  <basic-container>
    <el-row>
      <el-form inline>
        <el-form-item label="姓名">
          <el-input v-model="realName"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="phone"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchForm">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row gutter="20">
      <el-col :span="7">
        <el-tabs type="border-card">
          <el-tab-pane label="部门" style="height: 329px; overflow: scroll">
            <el-tree
              v-loading="treeLoading"
              :data="departmentTreeList"
              :props="defaultProps"
              @node-click="handleNodeClick"
            ></el-tree>
          </el-tab-pane>
          <el-tab-pane label="班组" style="height: 329px; overflow: scroll">
            <el-tree
              v-loading="treeLoading"
              :data="groupTreeList"
              :props="defaultProps_"
              @node-click="handleNodeClick_"
            ></el-tree>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="7">
        <div class="pane">
          <div
            item="for-select"
            name="item-for-select"
            style="cursor: pointer; padding: 1rem"
            @click="selectUserHandler($event)"
            v-for="(item, index) in dataForUserSelect"
            :key="index"
            :label="item.realNameAndPhone"
            :value="item.id"
          >
            {{ item.realNameAndPhone }}
          </div>
        </div>
      </el-col>
      <el-col span="3">
        <div style="flex: 2; text-align: center">
          <div style="margin: 20px 0">
            <el-button type="primary" @click="moveLeftAction" :disabled="moveLeftFlag"
              >左移</el-button
            >
          </div>
          <div style="margin: 20px 0">
            <el-button type="primary" @click="moveRightAction" :disabled="moveRightFlag"
              >右移</el-button
            >
          </div>
          <div v-if="single" style="margin: 20px 0">单选模式</div>
        </div>
      </el-col>
      <el-col span="7">
        <div class="pane">
          <div
            item="for-select"
            name="item-for-selected"
            style="cursor: pointer; padding: 1rem"
            @click="selectedUserHandler($event)"
            v-for="(item, index) in dataSelectedUsers"
            :key="index"
            :label="item.realNameAndPhone"
            :value="item.id"
          >
            {{ item.realNameAndPhone }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div style="text-align: center; padding: 1rem 0 0 0">
      <el-button type="primary" @click.native="submitSelectedUserList">提交</el-button>
      <el-button @click.native="closeUserEditBox">取消</el-button>
    </div>
  </basic-container>
</template>

<script>
import {
  getDepartmentTreeList,
  treeByProjectDeptId,
  getUserListByDepartmentId,
  getGroupList,
  getPrincipalUserList,
  getMenberUserList,
} from '@/api/crmedical/group/group';
export default {
  props: ['selectType', 'projectId', 'handleAction', 'remainUserListInside', 'single','userNum'],
  data() {
    return {
      realName: '',
      phone: '',
      treeLoading: false,
      moveLeftFlag: true,
      moveRightFlag: true,

      tempSelectedItemId: '',
      tempSelectedItemElement: '',

      dataForUserSelect: [],

      dataSelectedUsers: [],

      departmentTreeList: [],

      originUserList: [],

      groupTreeList: [],

      defaultProps: {
        children: 'children',
        label: 'title',
      },
      defaultProps_: {
        label: 'name',
      },
    };
  },
  watch: {
    remainUserListInside: {
      handler(val) {
        if (val) {
          this.dataSelectedUsers = this.deepClone(val);
        } else {
          this.dataSelectedUsers = this.deepClone(val);
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.remainUserListInside) {
      this.dataSelectedUsers = this.deepClone(this.remainUserListInside);
    } else {
      this.dataSelectedUsers = [];
    }

    treeByProjectDeptId({ projectId: this.projectId }).then((res) => {
      this.departmentTreeList = res.data;
    });
    getGroupList({ projectId: this.projectId }).then((res) => {
      this.groupTreeList = res.data;
    });
  },
  methods: {
    searchForm() {
      this.resetAllItem();
      getUserListByDepartmentId({
        realName: this.realName,
        phone: this.phone,
        projectId: this.projectId,
      }).then((res) => {
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);

        this.initDataForSelect();
      });
    },
    selectedUserHandler(e) {
      this.resetAllItem();
      if (this.tempSelectedItemId) {
        if (this.tempSelectedItemId === e.target.attributes.value.value) {
          e.target.style.backgroundColor = '';
          e.target.style.color = '';
          this.tempSelectedItemId = '';
          this.tempSelectedItemElement = '';
          this.moveLeftFlag = true;
        } else {
          this.tempSelectedItemId = e.target.attributes.value.value;
          this.changeRightSelectedItemStyle(e);
          this.tempSelectedItemElement = e.target;
          this.moveLeftFlag = false;
          this.moveLeftFlag = this.filterSelectedUsers();
        }
      } else {
        this.tempSelectedItemId = e.target.attributes.value.value;
        this.changeRightSelectedItemStyle(e);
        this.tempSelectedItemElement = e.target;
        this.moveLeftFlag = false;
        // this.moveLeftFlag = this.filterSelectedUsers();
      }
    },
    selectUserHandler(e) {
      //add
      if (this.single == true) {
        if (this.dataSelectedUsers.length > 0) {
          this.moveRightFlag = true;
          return;
        }
      }
      this.resetAllItem();
      if (this.tempSelectedItemId) {
        if (this.tempSelectedItemId === e.target.attributes.value.value) {
          e.target.style.backgroundColor = '';
          e.target.style.color = '';
          this.tempSelectedItemId = '';
          this.tempSelectedItemElement = '';
          this.moveRightFlag = true;
        } else {
          this.tempSelectedItemId = e.target.attributes.value.value;
          this.changeLeftSelectedItemStyle(e);
          this.tempSelectedItemElement = e.target;
          this.moveRightFlag = false;
        }
      } else {
        this.tempSelectedItemId = e.target.attributes.value.value;
        this.changeLeftSelectedItemStyle(e);
        this.tempSelectedItemElement = e.target;
        this.moveRightFlag = false;
      }
    },
    resetAllItem() {
      this.tempSelectedItemId = '';
      this.tempSelectedItemElement = '';
      this.moveRightFlag = true;
      this.moveLeftFlag = true;
      document.querySelectorAll('div[item="for-select"]').forEach((ele) => {
        ele.style.backgroundColor = '';
        ele.style.color = '';
      });
    },
    changeLeftSelectedItemStyle(e) {
      document.querySelectorAll('div[name="item-for-select"]').forEach((ele) => {
        ele.style.backgroundColor = '';
        ele.style.color = '';
      });
      e.target.style.backgroundColor = '#F5F7FA';
      e.target.style.color = '#409eff';
    },
    changeRightSelectedItemStyle(e) {
      document.querySelectorAll('div[name="item-for-selected"]').forEach((ele) => {
        ele.style.backgroundColor = '';
        ele.style.color = '';
      });
      e.target.style.backgroundColor = '#F5F7FA';
      e.target.style.color = '#409eff';
    },
    filterSelectedUsers() {
      let filterFlag = true;
      this.originUserList.forEach((element, index) => {
        if (this.tempSelectedItemId === element.id) {
          filterFlag = false;
        }
      });
      return filterFlag;
    },
    moveRightAction() {
      let self = this;
      this.dataForUserSelect.forEach((ele, index) => {
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataForUserSelect.splice(index, 1);
        }
      });

      this.dataSelectedUsers.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realNameAndPhone: this.tempSelectedItemElement.attributes.label.value,
      });
      this.resetAllItem();
    },
    moveLeftAction() {
      let self = this;
      this.dataSelectedUsers.forEach((ele, index) => {
        if (ele.id === self.tempSelectedItemElement.attributes.value.value) {
          this.dataSelectedUsers.splice(index, 1);
        }
      });

      this.dataForUserSelect.push({
        id: this.tempSelectedItemElement.attributes.value.value,
        realNameAndPhone: this.tempSelectedItemElement.attributes.label.value,
      });

      this.resetAllItem();
    },
    handleNodeClick(data) {
      this.treeLoading = true;
      this.resetAllItem();
      let deptId = data.id;
      getUserListByDepartmentId({ deptId }).then((res) => {
        res.data.forEach((ele, index) => {
          ele.realNameAndPhone = ele.realNameAndPhone;
        });
        this.originUserList = this.deepClone(res.data);
        this.dataForUserSelect = this.deepClone(res.data);

        this.initDataForSelect();
        this.treeLoading = false;
      });
    },
    //班组树点击
    handleNodeClick_(data) {
      this.treeLoading = true;
      this.resetAllItem();
      let groupId = data.id;
      if (this.selectType == 1) {
        //获取成员
        getMenberUserList({ groupId }).then((res) => {
          res.data.forEach((ele, index) => {
            ele.realNameAndPhone = ele.realNameAndPhone;
          });
          this.originUserList = this.deepClone(res.data);
          this.dataForUserSelect = this.deepClone(res.data);

          this.initDataForSelect();
          this.treeLoading = false;
        });
      } else {
        //获取负责人
        getPrincipalUserList({ groupId }).then((res) => {
          res.data.forEach((ele, index) => {
            ele.realNameAndPhone = ele.realNameAndPhone;
          });
          this.originUserList = this.deepClone(res.data);
          this.dataForUserSelect = this.deepClone(res.data);

          this.initDataForSelect();
          this.treeLoading = false;
        });
      }
    },
    // 移除掉可选列表中 已经选择的项
    initDataForSelect() {
      let arrListSelected = this.deepClone(this.dataSelectedUsers);
      let arrListForSelect = this.deepClone(this.dataForUserSelect);
      if (arrListSelected.length > 0) {
        arrListSelected.forEach((ele, i) => {
          arrListForSelect.forEach((element, index) => {
            if (element.id === ele.id) {
              arrListForSelect.splice(index, 1);
            }
          });
        });
      }
      this.dataForUserSelect = arrListForSelect;
    },
    closeUserEditBox() {
      this.$emit('closeAction');
    },
    submitSelectedUserList() {
      let idList = [];
      let idListString = '';
      let nameList = [];
      let nameListString = '';
      this.dataSelectedUsers.forEach((e, i) => {
        idList.push(e.id);
        nameList.push(e.realNameAndPhone);
      });
      if (idList.length > 0) {
        if(this.userNum&&idList.length>this.userNum){
           this.$message({
          message: '最大人数为'+this.userNum+"人",
          type: 'warning'
          });
          return
        }
        idListString = idList.join(',');
        nameListString = nameList.join(',');
        if (this.handleAction == 1) {
          this.$emit('update:remainUserListInside', this.dataSelectedUsers);
          this.$emit('submitAction', {
            selectType: this.selectType,
            idListString: idListString,
            nameListString: nameListString,
            dataSelectedUsers: this.dataSelectedUsers,
          });
        } else {
          this.$emit('update:remainUserListInside', this.dataSelectedUsers);
          this.$emit('editAction', {
            selectType: this.selectType,
            idListString: idListString,
            nameListString: nameListString,
            dataSelectedUsers: this.dataSelectedUsers,
          });
        }
      } else {
        if (this.handleAction == 1) {
          this.$emit('update:remainUserListInside', this.dataSelectedUsers);
          this.$emit('submitAction', {
            selectType: this.selectType,
            idListString: idListString,
            nameListString: nameListString,
            dataSelectedUsers: this.dataSelectedUsers,
          });
        } else {
          this.$emit('update:remainUserListInside', this.dataSelectedUsers);
          this.$emit('editAction', {
            selectType: this.selectType,
            idListString: idListString,
            nameListString: nameListString,
            dataSelectedUsers: this.dataSelectedUsers,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.pane {
  height: 400px;
  padding-left: 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  text-align: left;
  overflow: scroll;
}
</style>
